import styled, { css } from 'styled-components';
import { Switch } from 'antd';

export const Container = styled.div``;

export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin-bottom: 0.5rem;
    `}
`;

export const StyledSwitch = styled(Switch)``;
